<template>
  <div
    id="carouselMobile"
    class="carousel slide w-100 pl-4"
    data-bs-ride="carousel"
    data-bs-interval="10000"
  >
    <div class="carousel-inner h-100 overflow-hidden">
      <div
        v-for="(banner, index) in banners"
        :class="['carousel-item', { active: index === 0 }]"
      >
        <div class="w-100 px-4 pb-5 pt-4 h-100">
          <div class="mt-2 w-100">
            <h2 class="info-title">{{ banner.title }}</h2>
            <div class="info-button">
              {{ banner.button }}
            </div>
            <p class="info-detail">{{ banner.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <div
      style="left: 50%; bottom: 12px; transform: translate(-50%) rotate(180deg);"
      class="position-absolute d-flex justify-content-center align-items-center"
    >
      <a href="#carouselMobile" role="button" data-bs-slide="prev">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9425 19L17 17.9425L13.565 14.5L17 11.0575L15.9425 10L11.4425 14.5L15.9425 19Z"
            fill="#505050"
          />
        </svg>
      </a>
      <ol
        class="carousel-indicators signup-carousel position-relative my-0 mx-2"
      >
        <li data-bs-target="#carouselMobile" data-bs-slide-to="0" class="active"></li>
        <li data-bs-target="#carouselMobile" data-bs-slide-to="1"></li>
        <li data-bs-target="#carouselMobile" data-bs-slide-to="2"></li>
        <li data-bs-target="#carouselMobile" data-bs-slide-to="3"></li>
      </ol>
      <a href="#carouselMobile" role="button" data-bs-slide="next">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0575 9L11 10.0575L14.435 13.5L11 16.9425L12.0575 18L16.5575 13.5L12.0575 9Z"
            fill="#505050"
          />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import { getParam } from "~/utils";

export default {
  data: () => ({
    banners: [
      {
        ...signupBnrs.lead[0],
        title: "چرا پنل مدیریت لیدهای یکتانت؟",
        button: "جذب سریع و آسان مشتری برای کسب و کار شما",
        desc:
          "ما، مشتریانی که در همین لحظه به خدمات شما نیاز دارند را، با چند کلیلک، به شما معرفی می‌کنیم.",
      },
      {
        ...signupBnrs.lead[1],
        title: "چرا پنل مدیریت لیدهای یکتانت؟",
        button: "تبلیغات در وبسایت‌ها، اینستاگرام، تلگرام، پیامک و گوگل ادز",
        desc:
          "با اجرای تبلیغات در بسترهای مختلف، طیف متنوعی از مخاطبان علاقمند به خدمات شما را در دسترستان قرار خواهیم داد.",
      },
      {
        ...signupBnrs.lead[2],
        title: "چرا پنل مدیریت لیدهای یکتانت؟",
        button: "پرداخت به ازای هر لید",
        desc:
          "پرداختی شما به ازای لیدهای دریافت شده خواهد بود و در صورت تکمیل نشدن سفارش، هزینه اضافه پرداخت نخواهید کرد.",
      },
      {
        ...signupBnrs.lead[3],
        title: "چرا پنل مدیریت لیدهای یکتانت؟",
        button: "0 تا 100 اجرای تبلیغات با کارشناسان ما",
        desc:
          "با کمترین درگیری زمانی و فنی برای تیم شما، مخاطبین با کیفیت را به شما معرفی می‌کنیم.",
      },
    ],
    logo: signupBnrs.logo,
  }),
  methods: {
    getParam,
  },
};
</script>

<style scoped>
.carousel {
  height: 250px !important;
}

.info-title {
  width: 100%;
  text-align: right;
  font-size: 16px;
  font-weight: 700;
  color: #000;
}

.info-button {
  width: 100%;
  text-align: right;
  font-size: 20px;
  font-weight: 700;
  padding: 8px 20px;
  background: #fad400;
  color: #595959;
  margin-top: 12px;
  border-radius: 8px;
  direction: rtl;
}

.info-detail {
  width: 100%;
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  color: #8c8c8c;
  margin: 0;
  padding-top: 8px;
  direction: rtl;
}

/* .signup-carousel {
  bottom: unset !important;
} */
.signup-carousel li {
  background-color: #fed813;
  opacity: 0.3;
  margin-top: 22px;
}

.signup-carousel .active {
  opacity: 1 !important;
}
</style>
<style>
/* .vertical .carousel-item-next.carousel-item-left,
.vertical .carousel-item-prev.carousel-item-right {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.vertical .carousel-item-next,
.vertical .active.carousel-item-right {
  -webkit-transform: translate3d(0, 100%, 0);
  transform: translate3d(0, 100% 0);
}

.vertical .carousel-item-prev,
.vertical .active.carousel-item-left {
  -webkit-transform: translate3d(0, -100%, 0);
  transform: translate3d(0, -100%, 0);
} */
</style>
